exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-app {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  height: 100%;\n}\n", ""]);

